import * as d3 from "d3";
import React, { useEffect, useState } from "react";
// import { rgb } from 'd3-color';
import { scaleBand, scaleLinear } from "d3-scale";
// import {Typography} from '@material-ui/core';
// import { BorderColor } from '@material-ui/icons';

export default (props) => {
  const { data, highlight, size, color } = props;
  const { width } = size;
  const sortedData = data
    .slice()
    .filter((d) => d.value && d.value !== "" && !isNaN(d.value))
    .sort((a, b) => d3.descending(a.value, b.value));
  const highlightIndices = highlight.map((h) => h.index);
  const leftTextWidth = 10;
  const rightTextWidth = 10;
  const adjustedWidth = size.width - (leftTextWidth + rightTextWidth);
  const lineHeight = 100;
  const barPadding = 1;

  const [hoverCountry, setHoverCountry] = useState({
    item: null,
    isToolTip: false,
  });

  const useMousePosition = () => {
    const [mousePosition, setMousePosition] = useState({
      mouseX: null,
      mouseY: null,
    });

    const updateMousePosition = (ev) => {
      setMousePosition({ mouseX: ev.clientX, mouseY: ev.clientY });
    };

    useEffect(() => {
      window.addEventListener("mousemove", updateMousePosition);

      return () => window.removeEventListener("mousemove", updateMousePosition);
    }, []);

    return mousePosition;
  };

  const { mouseX, mouseY } = useMousePosition();

  const onMouseEnter = (item) => {
    // setTooltip({item:item});
    setHoverCountry({ item: item, isToolTip: true });
  };
  const onMouseLeave = (item) => {
    // setTooltip(false);
    setHoverCountry({ item: item, isToolTip: false });
  };

  const Tooltip = ({ country }) => {
    const tooltipWidth = 100;
    const tooltipHeight = tooltipWidth;

    return (
      <foreignObject
        style={{
          pointerEvents: "none",
        }}
        x={mouseX + tooltipWidth < size.x + width - tooltipWidth ? mouseX + 20 - size.x : mouseX - 10 - size.x - tooltipWidth}
        // y={ mouseY + 10 + 0.6*tooltipHeight < size.y + height
        //   ? mouseY - size.y
        //   : mouseY - size.y - (0.9*tooltipHeight)
        // }
        y={0}
        width={tooltipWidth}
        height={tooltipHeight}
      >
        <div
          className="tooltip"
          style={{
            backgroundColor: "rgb(80,128,94)",
            border: "1px solid",
            padding: "5px 5px 5px 5px",
            textAlign: "left",
            borderColor: "#fff",
          }}
        >
          {country.item && country.item.index ? (
            <div>
              {country.item.name}
              <br />
              Rank: #{country.item.rank}
            </div>
          ) : null}
        </div>
      </foreignObject>
    );
  };

  const max = d3.max(sortedData.map((d) => d.value));

  const scaleX = scaleBand()
    .domain(sortedData.map((d) => d.index))
    .range([0, adjustedWidth])
    .padding(barPadding);
  const scaleY = scaleLinear().domain([0, max]).range([0, lineHeight]);
  return (
    <div style={{ display: "flex" }}>
      <div
        style={{
          paddingLeft: leftTextWidth + "px",
          paddingRight: rightTextWidth + "px",
        }}
      >
        <svg className="lineMarker" width={adjustedWidth} height={lineHeight}>
          <g className="lineMarkerG" height={lineHeight}>
            {sortedData.map((m, i) => {
              return (
                <rect
                  height={scaleY(+m.value)}
                  width={adjustedWidth / sortedData.length - barPadding}
                  x={scaleX(m.index)}
                  y={lineHeight - scaleY(+m.value)}
                  fill={
                    highlightIndices.includes(m.index) || (hoverCountry.item && hoverCountry.item.index === m.index && hoverCountry.isToolTip)
                      ? color.highlight
                      : color.primary
                  }
                  onMouseEnter={() => onMouseEnter(m)}
                  onMouseLeave={() => onMouseLeave(m)}
                />
              );
            })}

            {hoverCountry.isToolTip && <Tooltip x={mouseX} y={mouseY} country={hoverCountry} />}
          </g>
        </svg>
      </div>
    </div>
  );
};
